import type { FlatMiniData, FlatSensorData } from './datalogTabTypes';

export interface DatalogColumnSpec<T> {
  key: string;
  header: string;
  accessorKey: keyof T & string;
  fallback?: string;
}

export function buildMiniDatalogColumns(
  timeHeader: string,
  hasTwa: boolean
): DatalogColumnSpec<FlatMiniData>[] {
  const cols: DatalogColumnSpec<FlatMiniData>[] = [
    { key: 'time', header: timeHeader, accessorKey: 'time_formatted' },
    { key: 'conc', header: 'Conc. (ppm)', accessorKey: 'gas_conc_formatted' },
  ];
  if (hasTwa) {
    cols.push(
      { key: 'stel', header: 'STEL', accessorKey: 'stel_conc_formatted' },
      { key: 'twa', header: 'TWA', accessorKey: 'twa_conc_formatted' }
    );
  }
  cols.push(
    { key: 'temp', header: 'Temp (°C)', accessorKey: 'temperature_formatted' },
    { key: 'battery', header: 'Battery (mV)', accessorKey: 'battery_volt_formatted' },
    { key: 'systemStatus', header: 'System Status', accessorKey: 'system_status_name' }
  );
  return cols;
}

export function buildLiteDatalogColumns(
  timeHeader: string,
  unitName: string,
  hasTwa: boolean,
  isLelSensor: boolean
): DatalogColumnSpec<FlatSensorData>[] {
  const cols: DatalogColumnSpec<FlatSensorData>[] = [
    { key: 'time', header: timeHeader, accessorKey: 'time_formatted' },
    { key: 'conc', header: `Conc. (${unitName})`, accessorKey: 'gas_conc_formatted' },
  ];
  if (hasTwa) {
    cols.push(
      { key: 'stel', header: 'STEL', accessorKey: 'stel_conc_formatted' },
      { key: 'twa', header: 'TWA', accessorKey: 'twa_conc_formatted' }
    );
  }
  cols.push(
    { key: 'temp', header: 'Temp (°C)', accessorKey: 'temperature_formatted' },
    { key: 'battery', header: 'Battery (mV)', accessorKey: 'battery_volt_formatted' }
  );
  if (isLelSensor) {
    cols.push({ key: 'lel', header: 'LEL Sensor (V)', accessorKey: 'lel_sensor_volt_formatted' });
  }
  cols.push(
    { key: 'systemStatus', header: 'System Status', accessorKey: 'system_status_name' },
    {
      key: 'sensorStatus',
      header: 'Sensor Status',
      accessorKey: 'sensor_status_name',
      fallback: '-',
    }
  );
  return cols;
}

export function toPlainRow<T>(row: T, columns: DatalogColumnSpec<T>[]): Record<string, unknown> {
  const plain: Record<string, unknown> = {};
  for (const col of columns) {
    plain[col.header] = row[col.accessorKey] ?? col.fallback ?? '';
  }
  return plain;
}
